import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { FiLock } from 'react-icons/fi';
import { confidentialityNote as defaultNote } from '../../config/credibilityConfig';

function ConfidentialityNote({ onCTAClick, variant = 'full' }) {
  const { t } = useTranslation();

  // Get translated content
  const text = t('confidentialityNote.text', { defaultValue: defaultNote.text });
  const subtext = t('confidentialityNote.subtext', { defaultValue: defaultNote.subtext });
  const ctaText = t('confidentialityNote.ctaText', { defaultValue: defaultNote.ctaText });

  const handleClick = () => {
    if (onCTAClick) {
      onCTAClick('Technical Discussion');
    }
  };

  // Compact variant for Contact section
  if (variant === 'compact') {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="flex items-center justify-center gap-2 text-center mt-8 pt-8 border-t"
        style={{ borderColor: 'rgba(16, 25, 87, 0.08)' }}
      >
        <FiLock className="text-sm" style={{ color: '#64748b' }} />
        <p className="text-xs" style={{ color: '#64748b' }}>
          <span className="font-medium">{text}</span>{' '}
          {subtext}
        </p>
      </motion.div>
    );
  }

  // Full variant - displayed under Delivered Capability Footprint
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="text-center py-8 px-6"
      data-testid="confidentiality-note"
    >
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center justify-center gap-2 mb-3">
          <FiLock className="text-base" style={{ color: '#101957' }} />
          <span 
            className="text-sm font-semibold"
            style={{ color: '#101957' }}
          >
            {text}
          </span>
        </div>
        <p 
          className="text-sm mb-4 leading-relaxed"
          style={{ color: '#64748b' }}
        >
          {subtext}
        </p>
        <button
          onClick={handleClick}
          className="inline-flex items-center gap-2 px-5 py-2 text-sm font-medium rounded-md transition-all duration-300"
          style={{ 
            backgroundColor: 'rgba(16, 25, 87, 0.06)',
            color: '#101957',
            border: '1px solid rgba(16, 25, 87, 0.15)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(16, 25, 87, 0.1)';
            e.currentTarget.style.borderColor = 'rgba(16, 25, 87, 0.25)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(16, 25, 87, 0.06)';
            e.currentTarget.style.borderColor = 'rgba(16, 25, 87, 0.15)';
          }}
        >
          {ctaText}
        </button>
      </div>
    </motion.div>
  );
}

export default ConfidentialityNote;
